import {
  ACCESS_REQUEST_ADD_MEMBER,
  ACCESS_REQUEST_GRANT_ACCESS,
  ADD_CONSTITUENT,
  closeRequestSuccess,
  DENY_REQUEST,
  FETCH_NETWORK_ACCESS_REQUESTS,
  FETCH_POSSIBLE_MATCHES,
  GET_MAGIC_PASSWORD,
  RESEND_ONBOARDING_EMAIL,
  receiveMagicPassword,
  receiveNetworkAccessRequests,
  receivePossibleMatches,
  UPDATE_MAGIC_PASSWORD,
} from "@/components/access/admin/ducks/Actions"
import {
  apiAccessRequestAddMember,
  apiAccessRequestGrantAccess,
  apiAddConstituent,
  apiDenyRequest,
  apiFetchNetworkAccessRequests,
  apiFetchPossibleMatches,
  apiGetMagicPassword,
  apiUpdateMagicPassword,
  resendOnboardingEmail,
} from "@/components/access/admin/ducks/AJAX"
import { NavigationActions } from "@/components/navigation/ducks/slice"
import { getUsers } from "@/components/permissions/admin/ducks/Actions"
import { setSelectedUserUrl } from "@/components/search/ducks/Actions"

export default (store) => (next) => (action) => {
  const { dispatch } = store

  const resendOnboardingSuccess = (cb) => (resp) => {
    if (!resp || !resp.description) {
      dispatch(NavigationActions.setSnackbar("Successfully sent onboarding email"))
    } else {
      dispatch(NavigationActions.setSnackbar(resp.description))
    }
    if (cb) {
      cb(resp)
    }
  }

  const resendOnboardingError = (cb) => () => {
    dispatch(NavigationActions.setSnackbar("Failed to send onboarding email"))
    if (cb) {
      cb()
    }
  }

  const receiveAddConstituentSuccess = (cb) => (response) => {
    if (cb) {
      cb()
    }
    dispatch(
      setSelectedUserUrl(
        response.constituent.constituentId,
        store.getState().customer.user.customer.id,
      ),
    )
    dispatch(getUsers(null, null, 0))
    dispatch(NavigationActions.setSnackbar("Successfully added member."))
  }

  const receiveMagicPasswordSuccess = (cb) => (resp) => {
    dispatch(receiveMagicPassword(resp.magicPassword))
    if (cb) {
      cb()
    }
  }
  const receiveNetworkAccessRequestsSuccess = (cb) => (response) => {
    if (cb) {
      cb()
    }
    dispatch(receiveNetworkAccessRequests(response.networkAccessRequests))
  }

  const closeRequest = (cb) => (response) => {
    if (cb) {
      cb()
    }
    if (response.result) {
      dispatch(NavigationActions.setSnackbar(response.result))
    }
    if (response.networkAccessRequests) {
      dispatch(receiveNetworkAccessRequests(response.networkAccessRequests))
    }
    dispatch(closeRequestSuccess())
  }

  switch (action.type) {
    case ACCESS_REQUEST_GRANT_ACCESS:
      apiAccessRequestGrantAccess(
        action.accessRequestId,
        action.constituentId,
        closeRequest(action.success),
        action.error,
      )
      return next(action)

    case ACCESS_REQUEST_ADD_MEMBER:
      apiAccessRequestAddMember(
        action.accessRequestId,
        action.constituent,
        closeRequest(action.success),
        action.error,
      )
      return next(action)

    case DENY_REQUEST:
      apiDenyRequest(action.accessRequestId, closeRequest(action.success), action.error)
      return next(action)

    case FETCH_NETWORK_ACCESS_REQUESTS:
      apiFetchNetworkAccessRequests(
        receiveNetworkAccessRequestsSuccess(action.success),
        action.error,
      )
      return next(action)

    case FETCH_POSSIBLE_MATCHES:
      apiFetchPossibleMatches(
        action.accessRequestId,
        receivePossibleMatches,
        action.error,
        action.success,
      )
      return next(action)

    case GET_MAGIC_PASSWORD:
      apiGetMagicPassword(receiveMagicPasswordSuccess(action.success), action.error)
      return next(action)

    case UPDATE_MAGIC_PASSWORD:
      apiUpdateMagicPassword(
        action.magicPassword,
        receiveMagicPasswordSuccess(action.success),
        action.error,
      )
      return next(action)

    case ADD_CONSTITUENT:
      apiAddConstituent(
        action.constituent,
        receiveAddConstituentSuccess(action.success),
        action.error,
      )
      return next(action)

    case RESEND_ONBOARDING_EMAIL:
      resendOnboardingEmail(
        action.constituentId,
        resendOnboardingSuccess(action.success),
        resendOnboardingError(action.error),
      )
      return next(action)

    default:
      return next(action)
  }
}
